import angular from "angular";

import ServiceProviderProfileModuleRouting from "./service-provider-profile.module.routing";

export default angular
  .module("vt-service-provider-profile", [])
  .config(ServiceProviderProfileModuleRouting);
